import { CrossIconvector } from 'assets/icons';
import { FC } from 'react';
import { Tag } from '../tags.model';

interface TagPillProps {
  tag: Tag;
  showCloseButton?: boolean;
  handleRemoveTag?: (tagId: string) => void;
  isDisabled?: boolean;
  className?: string;
  textStyle?: string;
  hideText?: boolean;
  contentRef?: React.RefObject<HTMLSpanElement>;
}

const isLightColor = (color: string) => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 186;
};

const TagPill: FC<TagPillProps> = ({
  tag,
  showCloseButton = false,
  handleRemoveTag,
  isDisabled,
  className,
  textStyle,
  hideText = false,
  contentRef = null
}) => {
  const textColor = isLightColor(tag.color) ? '#4F4F4F' : '#FFFFFF';

  return (
    <div
      className={`flex items-center gap-2 rounded-md px-4 py-2 text-17px ${className} ${
        isLightColor(tag.color) ? 'border border-secondaryBtn' : ''
      }`}
      style={{ backgroundColor: tag.color }}>
      {tag.icon && <span className={'text-17px'}>{tag.icon}</span>}
      {!hideText && (
        <span ref={contentRef} className={`font-semibold ${textStyle}`} style={{ color: textColor }}>
          {tag.name || 'Enter name'}
        </span>
      )}
      {showCloseButton && (
        <button className="cursor-pointer" onClick={() => handleRemoveTag(tag.id)} disabled={isDisabled}>
          <CrossIconvector className="path-fill-current" style={{ color: textColor }} width={12} height={12} />
        </button>
      )}
    </div>
  );
};

export default TagPill;
